import { useEffect, useState } from "react";
import styles from "./ExpenseSettings.module.css";
import { TextField, InputAdornment, Icon, IconButton } from "@mui/material";
import Store from "../../Store/Store";
import config from "../../config/config";
import axios from "axios";
import store from "../../Store/Store";
import { observer } from "mobx-react";
import { jwtDecode } from "jwt-decode";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  RespondToAuthChallengeCommand,
} from "@aws-sdk/client-cognito-identity-provider";
import { useDebouncedLog } from "../../useDebouncedLog";

const ExpenseSettings = observer(() => {
  const [smsToggle, setSmsToggle] = useState(false);
  const [SmsLimit, setSmsLimit] = useState("");
  const [NotificationToggle, setNotificationToggle] = useState(false);
  const [ReciptLimit, setReciptlimit] = useState("");
  const [LimitsUpdated, setLimitsUpdated] = useState(false);
  const [InvalidSmsNotification, setInvalidSmsNotification] = useState(false);
  const [InvalidReciptUpload, setInvalidReciptUpload] = useState(false);
  const [error, setError] = useState("");

  var logExpenseSettingVisited;
  var logCompanySettingsFetched;
  var logCompanySettingsUpdated;
  try {
    logExpenseSettingVisited = useDebouncedLog("admin_expense_setting_visited", 500);
    logCompanySettingsFetched = useDebouncedLog("admin_expense_setting_fetched", 500);
    logCompanySettingsUpdated = useDebouncedLog("admin_expense_setting_updated", 500);
  } catch (err) {
    console.log("error", err);
  }

  useEffect(() => {
    getAlertLimits();
  }, [store.refresh]);
  useEffect(() => { logExpenseSettingVisited() }, [logExpenseSettingVisited]);

  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);

      if (decoded && decoded.exp) {
        const currentTime = Math.floor(Date.now() / 1000); // Get current time in seconds
        return decoded.exp < currentTime;
      }
    } catch (error) {
      console.log("Error decoding token:", error);
      return true; // Treat decoding failures as expired tokens
    }
    return true;
  };

  const getNewTokens = async (authData) => {
    if (!authData?.RefreshToken) {
      localStorage.removeItem("authToken");
      // navigate("/login");
      return;
    }

    try {
      const client = new CognitoIdentityProviderClient({
        region: "ap-south-1",
      });

      const params = {
        ClientId: config.Client_Id,
        AuthFlow: "REFRESH_TOKEN_AUTH",
        AuthParameters: {
          REFRESH_TOKEN: authData?.RefreshToken,
        },
      };

      const command = new InitiateAuthCommand(params);
      const refreshResponse = await client.send(command);

      if (refreshResponse.AuthenticationResult) {
        const newAuthToken = {
          AccessToken: refreshResponse.AuthenticationResult.AccessToken,
          RefreshToken: authData?.RefreshToken, // Keep old refresh token
          IdToken: refreshResponse.AuthenticationResult.IdToken,
        };

        localStorage.setItem("authToken", JSON.stringify(newAuthToken));
        setAuth(newAuthToken); // Update state
        if (store.refresh) {
          store.setRefresh(false);
        } else {
          store.setRefresh(true);
        }
        return newAuthToken;
      } else {
        localStorage.removeItem("authToken");
        // navigate("/login");
      }
    } catch (error) {
      console.log("Error refreshing tokens:", error);
      localStorage.removeItem("authToken");
      // navigate("/login");
    }
  };

  const getAlertLimits = async () => {
    try {
      let tokens = localStorage.getItem("authToken");
      let parsedTokens = JSON.parse(tokens);
      let Obj = {
        ledger_label: Store.Company_Id,
      };
      const expired = isTokenExpired(parsedTokens.IdToken);
      if (expired) {
        parsedTokens = getNewTokens(parsedTokens);
      }
      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/get_company_config`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: Obj,
      };
      axios
        .request(payload)
        .then((res) => {
          try {
            logCompanySettingsFetched;
          } catch (err) {
            console.log("error", err);
          }
          const smsValue =
            Number(res.data.data.SmsnotificationAlert) >= 100000
              ? "disabled"
              : Number(res.data.data.SmsnotificationAlert);

          if (smsValue === "disabled" || smsValue === "disbled") {
            // Handle both cases for now
            console.log("SMS Notification is Disabled");
            setSmsToggle(false);
            setSmsLimit(""); // Set to empty string instead of 0 for a number input
          } else {
            setSmsToggle(true);
            setSmsLimit(smsValue); // Assuming this is a number
          }
          const receiptValue =
            Number(res.data.data.ReciptUpload) >= 100000
              ? "disabled"
              : Number(res.data.data.ReciptUpload);

          if (receiptValue === "disabled") {
            console.log("Receipt Upload is Disabled");
            setNotificationToggle(false);
            setReciptlimit(""); // Set to empty string instead of 0
          } else {
            setNotificationToggle(true);
            setReciptlimit(receiptValue); // Assuming this is a number
          }
        })

        .catch((err) => {
          console.log("Error %o", err);
        });
    } catch (err) {
      console.log("error%o", err);
    }
  };

  const UpdateLimits = async () => {
    try {
      let tokens = localStorage.getItem("authToken");
      let parsedTokens = JSON.parse(tokens);
      if (smsToggle && !SmsLimit) {
        console.log("in sms");

        if (NotificationToggle && !ReciptLimit) {
          console.log("in ReciptUpload");

          setInvalidReciptUpload(true);
        }
        setInvalidSmsNotification(true);
        return;
      }
      if (NotificationToggle && !ReciptLimit) {
        console.log("in ReciptUpload");
        setInvalidReciptUpload(true);
        return;
      }
      let Obj = {
        ledger_label: Store.Company_Id,
        SmsnotificationAlert: smsToggle ? SmsLimit : 10000000,
        ReciptUpload: NotificationToggle ? ReciptLimit : 10000000,
      };
      const expired = isTokenExpired(parsedTokens.IdToken);
      if (expired) {
        parsedTokens = getNewTokens(parsedTokens);
      }
      let payload = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${config.node_api_endpoint}/cupi/admin/update_company_config`,
        headers: {
          aws_cognito_id_token: parsedTokens.IdToken,
          aws_cognito_access_token: parsedTokens.AccessToken,
          "Content-Type": "application/json",
        },
        data: Obj,
      };
      axios
        .request(payload)
        .then(async (res) => {
          try {
            logCompanySettingsUpdated;
          } catch (err) {
            console.log("error", err);
          }
          setLimitsUpdated(true);
          console.log("limits being updated");
          await new Promise((resolve) => setTimeout(resolve, 3000));
          setLimitsUpdated(false);
        })
        .catch((err) => {
          console.log("Error %o", err);
        });
    } catch (err) {
      console.log("error%o", err);
    }
  };
  return (
    <div className={styles.frameParent}>
      <div className={styles.frameGroup}>
        <div className={styles.frameContent}>
          <div className={styles.frameHeader}>Set SMS Notification</div>
          <div className={styles.frameinnerContent}>
            <div className={styles.frameHeadings}>
              <div className={styles.frameHeader2}>SMS Notification</div>
              {Store.isUserOwner ? (
                <div
                  className={styles.frameButton}
                  onClick={() => {
                    if (Store.isUserOwner) {
                      smsToggle ? setInvalidSmsNotification(false) : "";
                      smsToggle ? setSmsToggle(false) : setSmsToggle(true);
                    }
                  }}
                >
                  <img
                    alt=""
                    src={smsToggle ? "/Track(Active).svg" : "/Track.svg"}
                    className={styles.btn_img}
                  />
                </div>
              ) : (
                <div className={styles.frameButton2}>
                  <img
                    alt=""
                    src={smsToggle ? "/Track(Active).svg" : "/Track.svg"}
                    className={styles.btn_img22}
                  />
                </div>
              )}
            </div>
            <div className={styles.frameInput}>
              <TextField
                className={styles.mobileMenu}
                color="primary"
                value={SmsLimit}
                disabled={!Store.isUserOwner ? true : false}
                label="Amount"
                // required
                type="number"
                onChange={(e) => {
                  setInvalidSmsNotification(false);
                  setSmsLimit(e.target.value);
                }}
                variant="outlined"
                sx={{
                  "& .MuiInputBase-root": {
                    height: "100%",
                    minHeight: "1.2rem",
                    border: InvalidSmsNotification ? "1px solid red" : "",
                  },
                  "& input[type=number]": {
                    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                  },
                  width: "100%",
                }}
              />
            </div>
            <div className={styles.frameNote}>
              {InvalidSmsNotification && (
                <div
                  className={styles.frameNote1}
                >{`Amount field cannot be blank. Please enter an amount.`}</div>
              )}
              <span className={styles.frameNoteSpan}>Note:</span> Set Minimum
              Transaction Amount for SMS Notification. <div></div>Rs 0.25 will
              be deducted from your Corporate Wallet for every SMS notification
              sent.
            </div>
          </div>
        </div>
        {Store.userType != "PineLabUser" && (
          <>
            <div className={styles.frameContent}>
              <div className={styles.frameHeader}>
                Set Mandatory Receipt Upload
              </div>
              <div className={styles.frameinnerContent}>
                <div className={styles.frameHeadings}>
                  <div className={styles.frameHeader2}>
                    Mandatory Receipt Upload
                  </div>
                  {Store.isUserOwner && Store.Company_Id != "EStackPine" ? (
                    <div
                      className={styles.frameButton}
                      onClick={() => {
                        if (
                          Store.isUserOwner &&
                          Store.Company_Id != "EStackPine"
                        ) {
                          NotificationToggle
                            ? setInvalidReciptUpload(false)
                            : "";
                          NotificationToggle
                            ? setNotificationToggle(false)
                            : setNotificationToggle(true);
                        }
                      }}
                    >
                      <img
                        alt=""
                        src={
                          NotificationToggle
                            ? "/Track(Active).svg"
                            : "/Track.svg"
                        }
                        className={styles.btn_img}
                      />
                    </div>
                  ) : (
                    <div className={styles.frameButton2}>
                      <img
                        alt=""
                        src={
                          NotificationToggle
                            ? "/Track(Active).svg"
                            : "/Track.svg"
                        }
                        className={styles.btn_img22}
                      />
                    </div>
                  )}
                </div>
                <div className={styles.frameInput}>
                  <TextField
                    className={styles.mobileMenu}
                    color="primary"
                    value={ReciptLimit}
                    label="Amount"
                    disabled={!Store.isUserOwner ? true : false}
                    type="number"
                    // required
                    onChange={(e) => {
                      if (Store.Company_Id == "EStackPine") {
                        return;
                      }
                      setInvalidReciptUpload(false);
                      setReciptlimit(e.target.value);
                    }}
                    variant="outlined"
                    sx={{
                      "& .MuiInputBase-root": {
                        height: "100%",
                        minHeight: "1.2rem",
                        border: InvalidReciptUpload ? "1px solid red" : "",
                      },
                      "& input[type=number]": {
                        "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                      },
                      width: "100%",
                    }}
                  />
                </div>
                <div className={styles.frameNote}>
                  {InvalidReciptUpload && (
                    <div
                      className={styles.frameNote1}
                    >{`Amount field cannot be blank. Please enter an amount.`}</div>
                  )}
                  <span className={styles.frameNoteSpan}>Note:</span> Set the
                  minimum transaction amount that requires a receipt. Employees
                  must upload a receipt before each transaction, or the next
                  payment will be blocked until it's submitted.
                </div>
              </div>
            </div>

          </>
        )}
        {LimitsUpdated && (
          <div className={styles.SuccessMessage}>
            <img
              alt=""
              src={"/check-circle.svg"}
              className={styles.btn_img}
            />
            {Store.userType != "PineLabUser" ? `The SMS notification & Mandatory receipt upload have been
                successfully set.`: `The SMS notification have been successfully set.`}
          </div>
        )}
        <div className={styles.frameButtonDiv}>
          {Store.isUserOwner ? ( //DONT ALLOW VIEW ADMIN
            <button
              className={styles.frameButton11}
              onClick={() => {
                UpdateLimits();
              }}
            >
              Apply
            </button>
          ) : (
            <button className={styles.frameButton12} onClick={() => { }}>
              Apply
            </button>
          )}
        </div>
      </div>
    </div>
  );
});
export default ExpenseSettings;
